import 'moment/locale/cs';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/fi';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/nl';
import { csCZ, deDE, enUS, esES, fiFI, frFR, itIT, nlNL } from '@mui/material/locale';
import { ResolvedIntlConfig } from 'react-intl';
import { LANGUAGES } from './config/consts';

type TranslationMessages = Record<string, string>;

const localeFileByLanguage: Record<string, string> = {
  [LANGUAGES.czech.locale]: 'cs',
  [LANGUAGES.dutch.locale]: 'nl',
  [LANGUAGES.english.locale]: 'en',
  [LANGUAGES.finnish.locale]: 'fi',
  [LANGUAGES.french.locale]: 'fr',
  [LANGUAGES.german.locale]: 'de',
  [LANGUAGES.italian.locale]: 'it',
  [LANGUAGES.spanish.locale]: 'es',
};

const getTranslationUrl = (localeFile: string) => {
  const publicUrl = process.env.PUBLIC_URL ?? '';
  const publicPath = publicUrl.endsWith('/') ? publicUrl.slice(0, -1) : publicUrl;

  return `${publicPath}/translations/${localeFile}.json`;
};

export async function getMessagesByLocale(locale: string): Promise<TranslationMessages> {
  const beStyleLocale = locale.replace('-', '_');
  const localeFile = localeFileByLanguage[beStyleLocale] ?? localeFileByLanguage[LANGUAGES.english.locale];
  // Vite does not support importing from public as source, so fetch the translations at runtime is needed.
  // this keeps the lang:compile output public and load it at runtime.
  const response = await fetch(getTranslationUrl(localeFile));

  if (!response.ok) {
    throw new Error(`Failed to load translations for locale "${locale}".`);
  }

  return response.json();
}

export const getMuiLocalizations = (locale: string) => {
  const beStyleLocale = locale.replace('-', '_');
  switch (beStyleLocale) {
    case LANGUAGES.english.locale:
      return enUS;
    case LANGUAGES.czech.locale:
      return csCZ;
    case LANGUAGES.german.locale:
      return deDE;
    case LANGUAGES.spanish.locale:
      return esES;
    case LANGUAGES.finnish.locale:
      return fiFI;
    case LANGUAGES.french.locale:
      return frFR;
    case LANGUAGES.italian.locale:
      return itIT;
    case LANGUAGES.dutch.locale:
      return nlNL;
    default:
      return enUS;
  }
};

export function getDefaultRichTextElements(): ResolvedIntlConfig['defaultRichTextElements'] {
  return {
    b: (chunks) => <b>{chunks}</b>,
    br: () => <br />,
    li: (chunks) => <li>{chunks}</li>,
    ol: (chunks) => <ol>{chunks}</ol>,
    p: (chunks) => <p>{chunks}</p>,
    strong: (chunks) => <strong>{chunks}</strong>,
    ul: (chunks) => <ul>{chunks}</ul>,
  };
}
